import { render, staticRenderFns } from "./bandoallegati-field.vue?vue&type=template&id=e4d830d2"
import script from "./bandoallegati-field.vue?vue&type=script&lang=js"
export * from "./bandoallegati-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports